import { formatDateOnly, parseDayMonthYear } from '../../../shared/utils/dateOnly';

export const formatDate = (dateValue) => {
  if (!dateValue) return '';
  const date = new Date(dateValue);
  if (isNaN(date.getTime())) return '';
  return `${String(date.getDate()).padStart(2, '0')}-${String(date.getMonth() + 1).padStart(2, '0')}-${date.getFullYear()}`;
};

// Fecha de nacimiento del servidor ('YYYY-MM-DD') -> 'DD-MM-YYYY' para el campo de texto.
export const formatBirthDate = (dateValue) => formatDateOnly(dateValue, '-');

// 'DD-MM-YYYY' -> 'YYYY-MM-DD' para enviar al servidor (sin pasar por Date/UTC).
export const parseDate = (dateText) => parseDayMonthYear(dateText);
